import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminDivionsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('division');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
